import LegalLayout, { LegalSection, LegalList } from "../../components/chalk/LegalLayout";

export default function RefundPolicy() {
  return (
    <LegalLayout title="Refund Policy" eyebrow="Legal" lastUpdated="February 2026" testId="page-refund-policy">
      <LegalSection heading="Summary">
        <LegalList items={[
          "Free trial available where shown.",
          "Users may cancel anytime.",
          "Subscription fees are non-refundable unless required by law.",
          "No prorated refunds for partial billing periods.",
          "Approved refunds are sent back to the original payment method.",
          <>Refund requests go to <a href="mailto:support@getchalkos.com" style={{ color: "#2E7D52" }}>support@getchalkos.com</a>.</>,
        ]} />
      </LegalSection>

      <LegalSection heading="How cancellation works">
        <p>
          You may cancel your Chalk OS subscription at any time from the Customer Portal in the More
          tab. Cancellation stops future renewals but does not refund the current billing period —
          your team keeps access until the end of the period you have already paid for.
        </p>
      </LegalSection>

      <LegalSection heading="How to request a refund">
        <p>
          Email <a href="mailto:support@getchalkos.com" style={{ color: "#2E7D52" }}>support@getchalkos.com</a>{" "}
          from the email address on the account. Include the team name, the charge date, and the
          reason for the request. We respond to refund requests within five business days.
        </p>
      </LegalSection>

      <LegalSection heading="When a refund may be approved">
        <p>
          We review refund requests case by case. Examples we will consider:
        </p>
        <LegalList items={[
          "A clear billing error on our side.",
          "A duplicate charge for the same subscription.",
          "A specific consumer-protection requirement that applies to your jurisdiction.",
        ]} />
        <p style={{ marginTop: 8 }}>
          Approved refunds are issued to the original payment method, typically within 5–10 business
          days of approval depending on the issuing bank.
        </p>
      </LegalSection>

      <LegalSection heading="Free trials">
        <p>
          When a free trial is offered, you will not be charged until the trial period ends. You may
          cancel anytime during the trial to avoid any charge.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
